// AI Generated Test
import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FastTrackTableService } from './fast-track-table.service';

@Component({
    selector: 'fast-track-table',
    standalone: false,
    template: `
        <div class="fast-track-table">
            <table class="table table-hover table-fixed">
                <thead>
                <tr>
                    <th class="col-lg-5"></th>
                    <th class="col-lg-35" translate>HTML snippet affecting compliance level</th>
                    <th class="col-lg-8 text-right">
                        <span class="inline-block pr-2" translate>Effect on compliance</span>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr *ngFor="let snippet of snippets; let i = index; trackBy: trackByIndex"
                    [ngClass]="{'selected': isSnippetSelected(snippet), focused: i === focusedSnippet }"
                    class="row-container">
                    <td class="text-left text-v-middle">
                        <button
                            (focus)="setFocusedSnippet(i)"
                            (blur)="setFocusedSnippet(null)"
                            class="open-snippet-details-button text-v-middle text-ellipsis"
                            (click)="onSetActiveSnippet({snippet: snippet})"
                        >
                            <span class="button-name">
                                {{'Show HTML snippet details' | translate}}
                            </span>
                        </button>
                        <span class="fa-2x fas fa-code pl-2 py-2" aria-hidden="true"></span>
                    </td>
                    <td class="button-container">
                        {{getSourceCode(snippet)}}
                    </td>
                    <td class="text-v-middle text-right">
                        <span class="font-weight-500 pr-2">
                            <span class="sr-only" translate>Effect on compliance</span>
                            {{ floorOrCeil(getCompliance(snippet)) }}%
                        </span>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    `,
})
export class FastTrackTableComponent {
    @Input() snippets: any;
    @Input() activeSnippet: any;
    @Output() setActiveSnippet = new EventEmitter<any>();

    focusedSnippet: any = null;

    constructor (private fastTrackTableService: FastTrackTableService) {}

    trackByIndex (index: number, item: any): number {
        return index;
    }

    isSnippetSelected (snippet: any): boolean {
        return Boolean(this.activeSnippet && this.activeSnippet.id === snippet.id);
    }

    getCompliance (snippet: any): any {
        return this.fastTrackTableService.getCompliance(snippet);
    }

    getSourceCode (snippet: any): any {
        return this.fastTrackTableService.getSourceCode(snippet);
    }

    floorOrCeil (val: any): any {
        return this.fastTrackTableService.floorOrCeil(val);
    }

    setFocusedSnippet (index: any): void {
        this.focusedSnippet = index;
    }

    onSetActiveSnippet (params: any): void {
        this.setActiveSnippet.emit(params);
    }
}
